import * as React from "react";
import { SpsDatepicker } from "./SpsDatepicker";
import { SpsCard } from "../card/SpsCard";

export class SpsDatepickerExample extends React.Component<{ "data-testid": any }> {
    // Used in react-live examples
    static testId = "sps-date-picker-basic";
    static reactLive = {
        code: `
        <SpsCard>
            <div className="row">
                <div className="mr-1 mb-1">
                    <SpsDatepicker></SpsDatepicker>
                </div>
            </div>
        </SpsCard>
        `
    };
    render() {
        const { "data-testid": testId } = this.props;
        // Used in react-testing-library specs
        return (
            <>
                <SpsCard>
                    <div className="row">
                        <div className="mr-1 mb-1">
                            <SpsDatepicker data-testid={testId} ></SpsDatepicker>
                        </div>
                    </div>
                </SpsCard>
            </>
        );
    }
}

export class SpsDatepickerDisabled extends React.Component<{ "data-testid": any }> {
    // Used in react-live examples
    static testId = "sps-date-picker-basic";
    static reactLive = {
        code: `
        <SpsCard>
            <div className="row">
                <div className="mr-1 mb-1">
                    <SpsDatepicker disabled></SpsDatepicker>
                </div>
            </div>
        </SpsCard>
        `
    };
    render() {
        const { "data-testid": testId } = this.props;
        // Used in react-testing-library specs
        return (
            <>
                <SpsCard>
                    <div className="row">
                        <div className="mr-1 mb-1">
                            <SpsDatepicker disabled data-testid={testId}></SpsDatepicker>
                        </div>
                    </div>
                </SpsCard>
            </>
        );
    }
}

export class SpsDatepickerMinMax extends React.Component<{ "data-testid": any }> {
    // Used in react-live examples
    static testId = "sps-date-picker-basic";
    static reactLive = {
        code: `
        <SpsCard>
            <div className="row">
                <div className="mr-1 mb-1">
                    <SpsDatepicker minDate={'05/02/2019'} maxDate={'06/12/2019'}></SpsDatepicker>
                </div>
            </div>
        </SpsCard>
        `
    };
    render() {
        const { "data-testid": testId } = this.props;
        // Used in react-testing-library specs
        return (
            <>
                <SpsCard>
                    <div className="row">
                        <div className="mr-1 mb-1">
                            <SpsDatepicker minDate={'05/02/2019'} maxDate={'06/12/2019'} data-testid={testId}></SpsDatepicker>
                        </div>
                    </div>
                </SpsCard>
            </>
        );
    }
}
